import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowForward } from '@mui/icons-material';
import './HomeAbout.css';

const HomeAbout: React.FC = () => {
  // Extract video ID from YouTube URL
  const videoId = 'x5pYnJ8YnwQ';
  const embedUrl = `https://www.youtube.com/embed/${videoId}`;

  return (
    <section className="py-20 bg-black text-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Content on the left */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="space-y-6"
          >
            <h2 
              className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 md:mb-6"
              style={{ 
                fontFamily: "'Montserrat', sans-serif",
                color: '#EF3F23'
              }}
            >
              Who we are
            </h2>
            
            <div className="space-y-3 md:space-y-4 text-white leading-relaxed text-sm sm:text-base" style={{ fontFamily: "'Poppins', sans-serif" }}>
              <p>
                Bizani Media Productions (Pvt) Ltd was founded in Zimbabwe in 2017. We are a content creation company that helps you to attract attention and communicate better about your work.
              </p>
              
              <p>
                Our company provides multimedia production services, including video production, documentaries, branding and digital services that help organizations of all sizes to meet their communication needs.
              </p>
              
              <p>
                The word 'bizani' means 'call' - to cry out and attract attention. We tell stories that engage, educate and activate audiences across all communication channels.
              </p>
            </div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.3 }}
            >
              <motion.div
                whileHover={{ y: -2 }}
                transition={{ duration: 0.2 }}
                className="inline-block"
              >
                <Link
                  to="/about"
                  className="button-hover group relative inline-flex items-center gap-2 px-6 py-3 rounded-lg font-headline font-bold transition-all duration-300 shadow-lg hover:shadow-xl"
                  style={{ 
                    border: '2px solid #EF3F23',
                    color: '#EF3F23',
                    backgroundColor: 'transparent'
                  }}
                >
                  <span className="button-text flex items-center gap-2">
                    View About
                    <ArrowForward style={{ fontSize: '18px' }} />
                  </span>
                </Link>
              </motion.div>
            </motion.div>
          </motion.div>

          {/* Video on the right */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="w-full"
          >
            <div className="relative rounded-lg overflow-hidden" style={{ paddingBottom: 'calc(56.25% + 40px)' }}>
              <iframe
                src={embedUrl}
                className="absolute inset-0 w-full h-full"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                title="Bizani Media About Video"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default HomeAbout;
